import React from "react";
import PropTypes from "prop-types";
import { Button } from "rhombus-react";
import { noop } from "utils/common";

import "./ContentFeedFooter.css";

export default function ContentFeedFooter({
	onCancel = noop,
	onBack = noop,
	onSave = noop,
	isSaveDisabled = false,
	isSaveLoading = false,
	saveTitle = "Save",
	cancelTitle = "Cancel",
	backTitle,
	saveTheme = "green",
}) {
	return (
		<div className="content-feed-footer">
			<div className="footer-buttons">
				<div className="footer-cancel-buttons">
					<Button
						name="cancelButton"
						onClick={onCancel}
						theme="default"
						className="button"
					>
						{cancelTitle}
					</Button>
					{backTitle && (
						<Button
							name="backButton"
							onClick={onBack}
							theme="default"
							className="button back-button-outlined"
						>
							{backTitle}
						</Button>
					)}
				</div>
				<Button
					name="saveButton"
					onClick={onSave}
					disabled={isSaveDisabled || isSaveLoading}
					theme={saveTheme}
					className="button save-button"
					icon={isSaveLoading ? "fa-regular fa-circle-notch circle-spin" : null}
				>
					{saveTitle}
				</Button>
			</div>
		</div>
	);
}

ContentFeedFooter.displayName = "ContentFeedFooter";

ContentFeedFooter.propTypes = {
	onCancel: PropTypes.func,
	onBack: PropTypes.func,
	onSave: PropTypes.func,
	isSaveDisabled: PropTypes.bool,
	isSaveLoading: PropTypes.bool,
	saveTitle: PropTypes.string,
	cancelTitle: PropTypes.string,
	backTitle: PropTypes.string,
	saveTheme: PropTypes.string,
};

